import React, { Component } from 'react';
import { getEntityList } from './GetListRequests';
import ReactLoading from 'react-loading';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';

import "./EntityList.css";

import EntityList_0 from './EntityTypeList/EntityList_0';
import EntityList_1 from './EntityTypeList/EntityList_1';
import EntityList_2 from './EntityTypeList/EntityList_2';
import EntityList_3 from './EntityTypeList/EntityList_3';

// import Entity from './Entity';

class EntityList extends Component {

	static defaultProps = {
		updateEntityList : () => {
			console.error("EntityList.updateEntityList props is ", null, " or ", undefined);
		},
		updateEntityDetail : () => {
			console.error("EntityList.updateEntityDetail props is ", null, " or ", undefined);
		},
		registUpdateEntity : () => {
			console.error("EntityList.registUpdateEntity props is ", null, " or ", undefined);
		},
		selectedEntityType : 0,
		typeEntityObject : {},
		isForInstance : false,
	}

	state = {
		selectedEntityType : 0,
	}

	allowedTypes = [0, 1, 2, 3]

	handleTypeOnChanged = (e) => {
		let { value } = e.target;
		
		if (typeof value !== 'number') {
			try {
				value = parseInt(value);
			} catch (e) {
				alert('엔티티 타입 to int parse 예외 처리');
				
			}
		}

		if (this.props.isForInstance) {
			this.setState({
				selectedEntityType : value,
			})
		} else {
			this.props.setEntityTypeSelection(value);
		}
	}

	handleClickAddEntityBtn = (e) => {
		e.stopPropagation();
		this.props.showCreateEntityModal();
	}

	deleteEntity = (type, id) => {
		this.props.deleteEntity(type, id);
	}

	render() {

		const renderEntityOptions = () => {
			const renderedOptions = [];
			this.allowedTypes.map( (type, i) => {
				
				
				if (this.props.disableTypes && this.props.disableTypes.find( disType => disType === type)) {
					return;
				}
				if ( type === this.props.selectedEntityType ) {
					renderedOptions.push(<option value={type} selected> {numberTypeToString(type)} </option>);
				} else {
					renderedOptions.push(<option value={type}> {numberTypeToString(type)} </option>);
				}
			})
			return renderedOptions
		};

		const renderListContent = () => {
			const {topicId} = this.props;
			const {updateEntityList} = this.props;
			const {typeEntityObject} = this.props;

			const selectedEntityType = this.props.isForInstance ? this.state.selectedEntityType : this.props.selectedEntityType;
			
			switch(selectedEntityType) {
				case 0:
					return (
						<EntityList_0 topicId={topicId}
							updateEntityList={updateEntityList}
							entityList={typeEntityObject[0]}
							updateEntityDetail={this.props.updateEntityDetail}
							deleteEntity={this.deleteEntity}
							registUpdateEntity={this.props.registUpdateEntity}
							isForInstance={this.props.isForInstance} />
					)
				break;

				case 1:
					return (
						<EntityList_1 topicId={topicId} 
							updateEntityList={updateEntityList}
							entityList={typeEntityObject[1]}
							updateEntityDetail={this.props.updateEntityDetail}
							deleteEntity={this.deleteEntity}
							registUpdateEntity={this.props.registUpdateEntity}
							isForInstance={this.props.isForInstance} />
					)
				break;

				case 2:
					return (
						<EntityList_2 topicId={topicId} 
							updateEntityList={updateEntityList}
							entityList={typeEntityObject[2]}
							updateEntityDetail={this.props.updateEntityDetail}
							deleteEntity={this.deleteEntity}
							registUpdateEntity={this.props.registUpdateEntity}
							isForInstance={this.props.isForInstance} />
					)
				break;

				case 3:
					if (!this.props.isForInstance) {
						return (
							<EntityList_3 topicId={topicId}
								updateEntityList={updateEntityList}
								entityList={typeEntityObject[3]}
								updateEntityDetail={this.props.updateEntityDetail}
								deleteEntity={this.deleteEntity}
								registUpdateEntity={this.props.registUpdateEntity}
								isForInstance={this.props.isForInstance} />
						)
					}
				break;

				default:
				alert("잘못된 엔티티 타입 입니다.");
			}
		}

		return (
			<div className="entity-list">
				<div className="entity-stack-wrapper">
					<div className="option-bar-area entity-list-options">
						{
							!this.props.isForInstance && (
								<button className="btn btn-success entity-option-btn create-entity-btn"
									onClick={this.handleClickAddEntityBtn} >
									<FontAwesomeIcon icon={faPlus} />
								</button>
							)
						}
						
						<select className="entity-type-select"
							onClick={(e) => {e.stopPropagation()}}
							onChange={this.handleTypeOnChanged}>
							{renderEntityOptions()}
						</select>

					</div>
					<div className="entity-stack">
						{renderListContent()}
					</div>
				</div>   
			</div>
    );
	}
}

const NotExistEntity = () => {
	return (
		<div className="not-exist-entity">
			<p> 엔티티가 존재하지 않습니다. </p>
		</div>
	);
}

const numberTypeToString = (type) => {
	switch(type) {
		case 0:
		return "사전 엔티티"
		break;
		
		case 1:
		return "정규식 엔티티"
		break;

		case 2:
		return "함수식 엔티티"
		break;
		
		case 3:
		return "그룹 엔티티"
		break;

		default:
		return "UNDEFINED"

	}
}

export default EntityList;